import { PackageEntityModel } from "src/store/models/entity/package/entity";
import { PackageHelperModel } from "src/store/models/entity/package/helper";

export const encooPackageModels = {
  entity: PackageEntityModel,
  helper: PackageHelperModel,
};
